import React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import { CircularProgress } from "@mui/material";
import { AccessData } from "../../api/models/access-model";
import AccessesCard from "../AccessesCard";
import IconifyIcon from "../IconifyIcon";
import SearchInput from "../FormElements/SearchInput";
import MobilePagination from "../MobilePagination";

interface RegisterLastLogsProps {
  isLoading: boolean;
  accesses: AccessData[] | null;
  getAccesses: () => void;
  searchValue: string;
  setSearchValue: (searchValue: string) => void;
  setShowAccessDetails: (showAccessDetails: boolean) => void;
  setSelectedAccessId: (selectedAccessId: string) => void;
  accessesPage: number;
  setAccessesPage: (accessesPage: number) => void;
  accessesPageSize: number;
  totalAccess: number;
}

const RegisterLastLogs = ({
  isLoading,
  accesses,
  getAccesses,
  searchValue,
  setSearchValue,
  setShowAccessDetails,
  setSelectedAccessId,
  accessesPage,
  setAccessesPage,
  accessesPageSize,
  totalAccess,
}: RegisterLastLogsProps) => {
  const labels = useAppSelector(selectLabels);

  const [showFilters, setShowFilters] = React.useState<boolean>(true);

  return (
    <div className="w-100 h-100 border-box">
      <div
        className="w-100 border-box flex align-items-center justify-content-between p-4 font-w-500"
        style={{
          height: 50,
          borderBottom: showFilters ? "1px white solid" : "1px #e0e0e0 solid",
          backgroundColor: "white",
          zIndex: 99,
        }}
      >
        <p className="font-16">{labels.last_logs}</p>
        <div className="flex align-items-center justify-content-end gap-4">
          <IconifyIcon
            className="pointer icon-button font-20"
            icon={showFilters ? "mdi:filter-off" : "mdi:filter"}
            onClick={() => setShowFilters(!showFilters)}
          />
          <IconifyIcon
            className="pointer icon-button font-20"
            icon={"zondicons:reload"}
            onClick={getAccesses}
          />
        </div>
      </div>
      {showFilters && (
        <div
          className="w-100 border-box flex flex-dir-col align-items-center justify-content-between px-4 pb-4 gap-4"
          style={{
            borderBottom: "1px #e0e0e0 solid",
            backgroundColor: "white",
            zIndex: 99,
          }}
        >
          <SearchInput
            value={searchValue}
            setValue={setSearchValue}
            size={"small"}
          />
        </div>
      )}
      {isLoading ? (
        <div
          className={`px-4 flex justify-content-center align-items-center ${showFilters ? "height-filters-small" : "height-no-filters"}`}
        >
          <CircularProgress />
        </div>
      ) : (
        <div
          className={`px-4 ${showFilters ? "height-filters-small" : "height-no-filters"}`}
          style={{ paddingBottom: 37 }}
        >
          {accesses && accesses.length > 0 ? (
            <>
              {accesses?.map((item, index) => (
                <div
                  key={`${item?.id}-${index}`}
                  className={
                    accesses.length - 1 === index ? "mt-4 mb-4" : "mt-4"
                  }
                >
                  <AccessesCard
                    access={item}
                    setShowAccessDetails={setShowAccessDetails}
                    setSelectedAccessId={setSelectedAccessId}
                  />
                </div>
              ))}
            </>
          ) : (
            <>
              <p className="text-center mt-10 title-color">
                {labels.no_results_found}
              </p>
            </>
          )}
        </div>
      )}
      <div
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
          zIndex: 99,
          borderTop: "1px #e0e0e0 solid",
        }}
      >
        <MobilePagination
          page={accessesPage}
          rowsPerPage={accessesPageSize}
          total={totalAccess}
          onChangePage={(p) => setAccessesPage(p)}
        />
      </div>
    </div>
  );
};

export default RegisterLastLogs;
